import { render, staticRenderFns } from "./odReceipt.vue?vue&type=template&id=1e029dd9&scoped=true"
import script from "./odReceipt.vue?vue&type=script&lang=js"
export * from "./odReceipt.vue?vue&type=script&lang=js"
import style0 from "./odReceipt.vue?vue&type=style&index=0&id=1e029dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e029dd9",
  null
  
)

export default component.exports